import { reactive } from "vue";
const stateStore = reactive({
    open: false,
    franchiseLogo: localStorage.getItem('USER_FRANCHISE_LOGO') || null,
    franchiseName: localStorage.getItem('USER_FRANCHISE_NAME') || null,
    franchiseFavicon: localStorage.getItem('USER_FRANCHISE_FAVICON') || null,
    showClosureModal: false,
    onChange() {
        stateStore.open = !stateStore.open;
    },
    toggleClosureModal(value) {
        stateStore.showClosureModal = value !== undefined ? value : !stateStore.showClosureModal;
    },
    setBranding(logo, name, favicon) {
        stateStore.franchiseLogo = logo;
        stateStore.franchiseName = name;
        stateStore.franchiseFavicon = favicon;
        if (logo)
            localStorage.setItem('USER_FRANCHISE_LOGO', logo);
        if (name)
            localStorage.setItem('USER_FRANCHISE_NAME', name);
        if (favicon)
            localStorage.setItem('USER_FRANCHISE_FAVICON', favicon);
    }
});
export default stateStore;
